(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/footer/footer.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/footer/footer.js');

'use strict';

const {
  useAtomValue
} = jotai;
const {
  activeMethodAtom
} = svs.iam_idp.atoms;
const {
  loginMethods
} = svs.iam_idp.constants;
const {
  ToggleCustomer,
  GetApp
} = svs.iam_idp.components.footer;
const Footer = () => {
  const activeMethod = useAtomValue(activeMethodAtom);
  return React.createElement("footer", {
    className: "footer"
  }, activeMethod === loginMethods.freja && React.createElement(ToggleCustomer, null), React.createElement(GetApp, null));
};
svs.iam_idp.components.footer.Footer = Footer;

 })(window);